var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00009 29C2.45107 29 1.90506 28.855 1.42204 28.5679C0.987556 28.3073 0.628968 27.9439 0.380149 27.5121C0.13133 27.0802 0.000494565 26.5942 0 26.0999V2.89953C0 1.89321 0.540016 0.959398 1.42204 0.431588C1.85749 0.17279 2.35388 0.0252968 2.86452 0.00297493C3.37517 -0.019347 3.8833 0.0842361 4.34113 0.303986L28.3419 11.9042C28.8402 12.1455 29.2592 12.5161 29.5521 12.9745C29.8449 13.4329 30 13.961 30 14.4997C30 15.0385 29.8449 15.5666 29.5521 16.025C29.2592 16.4834 28.8402 16.854 28.3419 17.0953L4.34113 28.6955C3.92112 28.8985 3.45611 29 3.00009 29Z",
    fill: "#3C1521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/GetStarted.3c7d6b4bdeb94f87d9e0bac3458a2163.svg";
export { ForwardRef as ReactComponent };